import { useStatQuery } from '@famly/stat_use-stat-query';
import { useSubscribableUpdateStaffingSettingsMutationResult } from '@famly/stat_settings_data';
import { useSubscribableToggleFeatureMutationResult } from './use-subscribable-toggle-feature-mutation';
import { StatFeatures } from './stat-features.query';
export function useStatFeaturesQuery(options) {
    const queryResult = useStatQuery(StatFeatures, options);
    useSubscribableToggleFeatureMutationResult(result => {
        if (result && queryResult.called) {
            queryResult.updateQuery(cached => {
                var _a;
                const { featureId, enabled } = (_a = result.institutions.managedFeatures.setFeatures[0]) !== null && _a !== void 0 ? _a : {};
                switch (featureId) {
                    case 'STAFF_HOURS_APPROVAL_OPT_IN':
                        if (cached.staffhours.featureSettings.approvalV2) {
                            cached.staffhours.featureSettings.approvalV2.enabledForAll = enabled;
                        }
                        else {
                            cached.staffhours.featureSettings.approvalV2 = {
                                canToggleForAll: true,
                                enabledForAll: true,
                            };
                        }
                        break;
                    // Care Rules is opt-out, so the managed feature is the inverse of the
                    // user-facing `isEnabled`
                    case 'CARE_RULES_OPT_OUT':
                        if (cached.featureSettings.careRules) {
                            cached.featureSettings.careRules.isEnabled = !enabled;
                        }
                        else {
                            cached.featureSettings.careRules = {
                                isEnabled: !enabled,
                                canToggle: true,
                            };
                        }
                        // The backend derives careSummary.isEnabled from care rules being enabled,
                        // so it has to move with it or the care summary report stays visible for a
                        // site that just turned care rules off
                        cached.featureSettings.careSummary.isEnabled = !enabled;
                        break;
                    default:
                    // nothing to be done
                }
                return cached;
            });
        }
    });
    // When updating the staffing settings, we also update two feature flags as part of the request.
    // Hence, we need to update the stat features cache
    useSubscribableUpdateStaffingSettingsMutationResult(result => {
        if (result && queryResult.called) {
            queryResult.updateQuery(cached => {
                var _a, _b;
                cached.staffhours.featureSettings.subtype.isRestricted =
                    (_a = result.staffhours.settings.updateAll.subTypeIsRestricted) !== null && _a !== void 0 ? _a : false;
                cached.staffhours.featureSettings.subtype.required =
                    (_b = result.staffhours.settings.updateAll.subTypeIsRequired) !== null && _b !== void 0 ? _b : false;
                return cached;
            });
        }
    });
    return queryResult;
}
